module.exports = __webpack_public_path__ + "static/app-61c117dfc061b428af821290b3607e58.png";